<template>
  <ProductDescription :product="product" />
  <VariantList :product-id="product.id" :variants="product.variants" />
  <div class="text-center mt-8">
    <GenericButton @click="this.redirectToPreviousPage">
      {{ $t("Back") }}
    </GenericButton>
  </div>
</template>

<script>
import { GenericButton } from "@estaly/ui";
import ProductDescription from "@/views/products/details/description/ProductDescription.vue";
import VariantList from "@/views/products/details/variant/VariantList.vue";
import { mapActions } from "vuex";
export default {
  components: {
    VariantList,
    ProductDescription,
    GenericButton,
  },
  data: () => {
    return {
      product: {},
    };
  },
  methods: {
    ...mapActions("products", ["fetch"]),
    async getProduct() {
      const productId = this.$route.params.id;
      this.product = await this.fetch({ id: productId, includes: ["variants.matched_contracts", "variants"] });
    },
    redirectToPreviousPage() {
      this.$router.push("/products");
    },
  },
  created() {
    this.getProduct();
  },
};
</script>
